<template>
  <div class="smart-voice-edit">
    <div class="content">
      <div class="reader" v-if="currReader">
        <div class="roles-wrapper" v-if="rolesOpened" @click.stop>
          <Roles
            :readerOpts="readerOpts"
            :readerTabs="readerTabs"
            :readerData="currReader"
            @close="closeRoles"
            @updateReader="updateReader"
          ></Roles>
        </div>
        <div class="figure" @click="openRoles(true)">
          <div class="mask">
            <i class="iconfont iconhuanyihuan" style="color: #fff"></i>
          </div>
          <img :src="$handleAssetsUrl(currReader.iconUrl)" alt="" />
        </div>
        <div class="name">{{ currReader.label }}</div>
      </div>

      <div class="text-wrapper">
        <textarea
          class="textarea"
          contenteditable
          :placeholder="textarea.placeholder"
          @keydown.stop="limitTextarea($event)"
          @click="limitTextarea($event)"
          @select="onSelectText"
          @paste="onPaste"
          v-model="textarea.value"
          ref="textareaRef"
        >
          <!-- {{ textarea.value }} -->
          </textarea
        >
      </div>
      <div class="control">
        <div class="row">
          <div class="row-item__name">插入停顿(s):</div>
          <div class="row-item__content df">
            <div
              class="btn-small margin"
              v-for="(item, i) in insertSpace"
              :key="i"
              @click="
                insertSpaceRecord({
                  sec: item.value,
                })
              "
            >
              {{ item.value }}
            </div>
          </div>
        </div>

        <div class="row">
          <div class="row-item__name">功能:</div>
          <!-- 下拉菜单 -->
          <div class="menu-container row-item is-grow">
            <!-- <div class="name">特殊发音：</div> -->
            <Menu
              :title="'多音字'"
              :options="polyphoneList"
              @triggerOn="onPolyphoneMenuToggle"
              @clickItem="setCharPolyphone"
            >
              <template v-slot:icon>
                <iconfont
                  name="#iconduoyinzi"
                  font-size="16px"
                  style="margin-right: 2px"
                ></iconfont>
              </template>
            </Menu>
            <div style="width: 10px"></div>
            <Menu
              :title="'数字读法'"
              :options="numberList"
              @triggerOn="onNumberMenuToggle"
              @clickItem="setNumberSpeaking"
            >
              <template v-slot:icon>
                <iconfont
                  name="#iconshuzidufa"
                  font-size="20px"
                  style="margin-right: 6px; margin-top: 2.5px"
                ></iconfont>
              </template>
            </Menu>
          </div>
        </div>

        <div
          class="speed-range row"
          :text="speeds[providerType]"
          :text1="providerType"
        >
          <div class="row-item__name">语速:</div>
          <div class="content">
            <div class="range-wrapper">
              <SpeedRange
                v-if="currReader.maxSpeed < Infinity"
                v-model="speeds[currReader.provider]"
                :min="currReader.minSpeed"
                :max="currReader.maxSpeed"
                :step="rangeStep"
                :classes="['small']"
                ref="speedRange"
              ></SpeedRange>
            </div>
          </div>
        </div>
      </div>

      <div class="test-play-row">
        <div
          class="test-play"
          :class="{ 'is-disabled': false }"
          @click="testPlay()"
          ref="testPlayBtn"
        >
          <div class="figure">
            <svg
              viewBox="0 0 1024 1024"
              width="36"
              height="36"
              v-show="!playing"
            >
              <circle id="gfg" cx="512" cy="512" r="512" fill="#5778FB" />
              <path
                d="M398.222222 307.768889v408.462222c0 19.911111 29.013333 30.72 47.217778 17.635556l284.444444-204.231111a20.48 20.48 0 0 0 0-34.702223l-284.444444-204.8c-18.204444-13.084444-47.217778-2.275556-47.217778 17.635556z"
                fill="#FFFFFF"
                p-id="3227"
              ></path>
            </svg>
            <svg
              v-show="playing"
              class="icon"
              style="width: 36px; height: 36px"
              viewBox="0 0 1024 1024"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle id="gfg" cx="512" cy="512" r="512" fill="#5778FB" />
              <path
                d="M369.777778 284.444444m42.666666 0l0 0q42.666667 0 42.666667 42.666667l0 369.777778q0 42.666667-42.666667 42.666667l0 0q-42.666667 0-42.666666-42.666667l0-369.777778q0-42.666667 42.666666-42.666667Z"
                fill="#FFFFFF"
                p-id="4794"
              ></path>
              <path
                d="M568.888889 284.444444m42.666667 0l0 0q42.666667 0 42.666666 42.666667l0 369.777778q0 42.666667-42.666666 42.666667l0 0q-42.666667 0-42.666667-42.666667l0-369.777778q0-42.666667 42.666667-42.666667Z"
                fill="#FFFFFF"
                p-id="4795"
              ></path>
            </svg>
          </div>
          <div class="label">
            <span>试听</span>
            <!-- {{testingVoiceMsg}}
            <span v-if="audioDur" style="opacity: 0.7;font-size: 12px;">（时长: {{ audioDur }}s）</span> -->
            <div class="icon-free"></div>
          </div>
        </div>
      </div>

      <RecordPlayer
        ref="recordPlayer"
        @playStart="playStart"
        @playPaused="playPaused"
        @loadedMeta="onLoadedMeta"
      ></RecordPlayer>
    </div>
    <div class="footer">
      <div class="btn-cancel" @click="cancel">取消</div>
      <div
        class="btn-edit"
        :class="{ 'is-disabled': !allowedTest }"
        @click="confirm()"
      >
        确定修改
      </div>
    </div>

    <div
      class="progress __smart-voice"
      ref="progressRef"
      v-show="false"
      style="
        position: fixed;
        top: 50%;
        left: 50%;
        width: 126px;
        height: 126px;
        transform: translate(-50%, -50%);
      "
    >
      <div class="lds-default">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div class="progress__text">正在合成语音</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import base from '../dialogs/smartVoice/voiceEditor';
import Menu from '../dialogs/smartVoice/menu';
import RecordPlayer from '@/components/emodal/generateVoice/recordPlayer';
import SpeedRange from '../dialogs/smartVoice/range.vue';
import Roles from './smartVoiceEdit/roles';
import testVoice from '../../mixins/testVoice';

export default {
  mixins: [base, testVoice],
  components: {
    Menu,
    RecordPlayer,
    SpeedRange,
    Roles
  },
  props: {
    voice: {},
    readerOpts: {},
    readerTabs: {},
    voiceData: {}
  },
  data () {
    return {
      currReader: {},
      rolesOpened: false,
      playing: false
    }
  },
  computed: {
    ...mapGetters({
      receiveData: "addSoundtrack/getReceiveData",
      dubbingArr: "addSoundtrack/getDubbingArr",
      getSelectDubbing: "addSoundtrack/getSelectDubbing",
      getDubbingIndex: 'addSoundtrack/getDubbingIndex',
      TOOL: 'TOOL',
      UserMsg: 'UserMsg'
    }),
    readerData_ () {
      const readerId = this.voice.speakerId;
      return this.readerOpts.find(v => readerId ? v.id === readerId : v.value === this.voice.speaker);
    },
    providerType () {
      return this.currReader.provider;
    },
    rangeStep () {
      return (this.currReader.maxSpeed - this.currReader.minSpeed) / 8;
    },
    allowedTest () {
      if (this.UserLevelInfo.levelName === 'basic' && this.testingVoiceInfo.remain === 0) {
        return false;
      }
      return this.textarea && this.getTextLength(this.textarea.value);
    }
  },

  created () {
    this.$bus.on('smartVoice.generating', this.onGenerating);
    this.textarea.value = this.voice.text;
    let decoded = this.decodeText(this.voice.text);
    this.listenedParams = {
      speed: this.voice.speed,
      speaker: this.voice.speaker,
      text: decoded.text,
      pause_points: decoded.points,
      type: 1
    }
    this.fetchTestVoiceCount();
  },
  beforeDestroy () {
    this.$bus.off('smartVoice.generating', this.onGenerating);
  },
  mounted () {
    this.currReader = this.readerData_;
    let providerType = this.currReader.provider;
    this.speeds[providerType] = +this.voice.speed;
  },
  methods: {
    handleReader () {

    },
    playStart () {
      this.playing = true;
    },
    playPaused () {
      this.playing = false;
    },
    openRoles (flag = true) {
      this.rolesOpened = flag;
    },
    closeRoles () {
      this.openRoles(false);
    },
    onGenerating (val) {
      if (val) {
        let ref = this.$refs.progressRef;
        if (ref) {
          let mask = document.body.querySelector(".gene_recoring");
          ref.style.zIndex = mask.style.zIndex - 0 + 10;
          let clone = ref.cloneNode(true);
          clone.style.display = '';
          document.body.appendChild(clone);
        }
      } else {
        $('body > .progress.__smart-voice').remove();
      }
    },
    cancel () {
      this.$emit('cancel');
    },
    async confirm () {
      const isEnterpriseSpeaker = (this.readerOpts.filter(item => item.aiType) || []).some(v => v.id ? v.id === this.currReader.id : v.sourceId === this.currReader.sourceId);
      if (!this.UserMsg.aiType && isEnterpriseSpeaker) {
        this.$memberGuide({
          show: true,
          context: this,
          isSubtitle: true,
          funcRight: {
            type: "enterpriseSpeaker",
            name: "企业专属音色",
          },
        });
        return;
      }
      if (!this.allowedTest) return;
      let voice = await this.send({ type: 1, isSaveStore: false });
      let worksList = this.$store.getters['smartVoice/worksList'];
      worksList = [...worksList, {
        pause_points: this.listenedParams.pause_points,
        provider: this.providerType,
        speaker: this.currReader.value,
        speed: this.speeds[this.providerType],
        text: this.$refs.textareaRef.value,
        url: this.$unhandleAssetsUrl(voice.url)
      }];
      this.dubbingArr.some(v => {
        v.url === voice.url && v.timeSlot[0] === voice.time;
      });
      let o = this.dubbingArr[this.getDubbingIndex];
      let toolDur = this.TOOL.getDuration() / 1000;
      let end = Math.min(o.timeSlot[0] + this.audioDur, toolDur);
      let nextOne = this.dubbingArr[this.getDubbingIndex + 1];
      if (nextOne && nextOne.timeSlot[0] - 0.2 < end) {
        end = nextOne.timeSlot[0] - 0.2;
      }
      let dubbing = {
        title: this.$refs.textareaRef.value.slice(0, 5) + '-' + this.currReader.label,
        text: this.$refs.textareaRef.value,
        url: this.$unhandleAssetsUrl(voice.url),
        cut: [0, this.audioDur],
        timeSlot: [o.timeSlot[0], end]
      };
      this.replaceDubbing(dubbing, this.getDubbingIndex);

      this.$store.commit('smartVoice/setWorksList', worksList);

      this.$http
        .post("/api/user/music", {
          url: dubbing.url,
          title: dubbing.title,
          duration: this.audioDur,
          musicType: 2,
          fileType: 50
        })
        .then(({ data: resData }) => {
          let { data, code, msg } = resData;
          if (code !== 200) {
            this.$message({
              message: msg,
              type: "error"
            });
            return;
          }
        })
        .catch(err => {

        });
      this.$emit('cancel');
    },
    replaceDubbing (dubbing, index) {
      let reData = {};
      let select = this.$store.getters["addSoundtrack/getSelectDubbing"];
      for (let key in dubbing) {
        reData[key] = select[key];
      }
      reData = JSON.stringify(reData);
      this.$store.commit("addSoundtrack/updateDubbing", {
        dubbing: dubbing,
        index: index,
      });
      this.$bus.emit("replace_current_dubing", {
        event: "replace",
      });
      this.$bus.emit("insert_subtitle_undo", {
        type: "updateDubbing",
        data: {
          index: index,
          data: JSON.stringify(dubbing),
          reData: reData,
        },
      });
    },
    updateReader (val) {
      this.currReader = this.readerOpts.find(v => val.id ? v.id === val.id : v.value === val.value);
      this.$emit('updateReader', this.currReader);
    }
  }
}
</script>

<style lang="scss" scoped>
.icon-free {
  width: 30px;
  height: 17px;
  background-image: url(../../../assets/smartVoice/free.png);
  background-repeat: no-repeat;
  background-size: 100% 100%;
  margin-top: -2px;
  margin-left: 6px;
}
.smart-voice-edit {
  height: 100%;
  color: #474261;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  & .footer {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding: 15px 10px;
    & .btn-edit {
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      width: 105px;
      height: 30px;
      background: #5778fb;
      border-radius: 4px;
      cursor: pointer;
      &:hover {
        background-color: #7d95f5;
        &.is-disabled {
          background: #5778FB;
        }
      }
    }
    & .btn-cancel {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 60px;
      height: 30px;
      background: #ffffff;
      border: 1px solid #d9ddea;
      opacity: 1;
      border-radius: 4px;
      color: #737596;
      cursor: pointer;
      margin-right: 14px;
      &:hover {
        opacity: 0.8;
      }
    }
  }
}
.reader {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 20px 10px 6px;
  cursor: pointer;
  & .roles-wrapper {
    position: absolute;
    right: calc(100% - 5px);
    top: 19px;
    cursor: default;
    z-index: 200;
  }
  & .figure {
    position: relative;
    width: 26px;
    height: 26px;
    background: #d8dee9;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 6px;
    & > .mask {
      display: flex;
      align-items: center;
      justify-content: center;
      display: none;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(#000, 0.5);
    }
    &:hover > .mask {
      display: flex;
    }
  }
  & .label {
    color: #474261;
  }
}
.text-wrapper {
  width: 226px;
  margin: auto;
  background: #f8f8fb;
  opacity: 1;
  border-radius: 4px;
  color: #898d96;
  overflow: auto;

  .textarea {
    overflow: auto;
    resize: none;
    height: 226px;
    padding: 11px 10px;
    line-height: 16px;
    width: 100%;
    border: none;
    background: #f8f8fb;
    color: #898d96;

    &::-webkit-scrollbar {
      width: 6px;
      height: 8px;
    }
    &::-webkit-scrollbar-track {
      background: transparent;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb {
      background: #d8dee9;
      border-radius: 4px;
    }
    &::-webkit-scrollbar-thumb:hover {
      background: #bdbdbe;
    }
  }
}
.control {
  margin-top: 3px;
  width: 451px;
  height: 130px;
  background: #ffffff;
  font-size: 12px;
  & > .row {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    height: 26px;
    margin-top: 18px;
    margin-bottom: 18px;
    padding-left: 10px;
  }
  & .row-item {
    display: flex;
    align-items: center;
    &__name {
      display: flex;
      align-items: center;
      color: #737596;
    }
    &__content {
      display: flex;
      align-items: center;
    }
    &__content .btn-small {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 24px;
      height: 24px;
      background: #f6f6fc;
      border: 1px solid #d8dee9;
      border-radius: 4px;
      font-size: 12px;
      color: #737596;
      margin-left: 10px;
      cursor: pointer;
    }
  }
  & .menu-container {
    margin-left: 8px;
  }
  & .speed-range {
    display: flex;
    align-items: center;
    & > .content {
      margin-left: 12px;
      height: 42px;
      display: flex;
      align-items: flex-end;
    }
    & .range-wrapper {
      height: 16px;
    }
  }
}
.test-play-row {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 36px;
  padding-top: 30px;
}
.test-play {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #898d96;
  & .figure {
    margin-right: 10px;
  }
  &:hover {
    opacity: 0.8;
  }
  .label {
    display: flex;
    align-items: center;
  }
}
.is-disabled {
  opacity: 0.2 !important;
  cursor: not-allowed !important;
}

.progress {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  &__text {
    text-align: center;
  }
}

.lds-default {
  position: relative;
  display: inline-block;
  width: 64px;
  height: 64px;
}
.lds-default div {
  position: absolute;
  width: 5px;
  height: 5px;
  background: #5778fb;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}
.lds-default div:nth-child(1) {
  top: 29px;
  left: 53px;
  animation-delay: 0s;
}
.lds-default div:nth-child(2) {
  top: 18px;
  left: 50px;
  animation-delay: -0.1s;
}
.lds-default div:nth-child(3) {
  top: 9px;
  left: 41px;
  animation-delay: -0.2s;
}
.lds-default div:nth-child(4) {
  top: 6px;
  left: 29px;
  animation-delay: -0.3s;
}
.lds-default div:nth-child(5) {
  top: 9px;
  left: 18px;
  animation-delay: -0.4s;
}
.lds-default div:nth-child(6) {
  top: 18px;
  left: 9px;
  animation-delay: -0.5s;
}
.lds-default div:nth-child(7) {
  top: 29px;
  left: 6px;
  animation-delay: -0.6s;
}
.lds-default div:nth-child(8) {
  top: 41px;
  left: 9px;
  animation-delay: -0.7s;
}
.lds-default div:nth-child(9) {
  top: 50px;
  left: 18px;
  animation-delay: -0.8s;
}
.lds-default div:nth-child(10) {
  top: 53px;
  left: 29px;
  animation-delay: -0.9s;
}
.lds-default div:nth-child(11) {
  top: 50px;
  left: 41px;
  animation-delay: -1s;
}
.lds-default div:nth-child(12) {
  top: 41px;
  left: 50px;
  animation-delay: -1.1s;
}
@keyframes lds-default {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/dubbing/smartVoiceEdit.vue